export default "/kiban/_next/static/images/27_8L_3-2-3_withoutBH_staggered-d75d2266f4725258c28ee83a2f939fbc.png";